import React, { useState,useEffect } from 'react';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import Cookies from 'universal-cookie';
import Filter from './Filter.js';
import Item from './Item.js';
import '../styles/goods.scss';

const Goods = (props) => {
  const { showFilter,type,onFilterClose } = props;
  const [ members, setMembers ] = useState(["collar","candy","day","gao","ivy","marf","soching","sumling","winka"]);
  const [ types, setTypes ] = useState(["reserve","walkin","preview"]);
  const [ payments, setPayments ] = useState(["free","paid"]);
  const [ methods , setMethods ] = useState(["inPerson","sf","post","shop"]);
  const [ pageNum , setPageNum ] = useState(0);
  const [ dateRange , setDateRange ] = useState([
    {
      startDate: new Date(),
      endDate: null,
      key: 'selection'
    }
  ]);
  const [ loading , setLoading ] = useState(null);
  const [ hasMore , setHasMore ] = useState(true);
  const [ needMore , setNeedMore ] = useState(false);
  const [ filter , setFilter ] = useState(null);
  const [ goods, setGoods ] = useState([]);
  const [ background, setBackground] = useState(null);
  const { innerWidth: width } = window;
  var yDown = null;
  const cookies = new Cookies();

  function handleFilterClose(e){
    onFilterClose(e);
  }

  function swipeStart(e){
    const firstTouch = e.touches[0];
    yDown = firstTouch.clientY;
  }

  function swipeMove(e){
    if (!yDown ) {
        return;
    }
    var yUp = e.touches[0].clientY;
    var element = document.body;
    var yDiff = yDown - yUp;
    if ( yDiff > 0 ) {
      var element = document.body;
      if(element.scrollHeight - window.innerHeight - window.scrollY < 50)
      {
        setNeedMore(true);
      }
    }
    yDown = null;
  }

  function scroll(e){
    var element = document.body;
    if(element.scrollHeight - window.innerHeight - window.scrollY < 50)
    {
      setNeedMore(true);
    }
  }

  function addInfiniteScroll(){
    window.addEventListener('wheel',scroll, { passive: true });
    window.addEventListener('touchstart',swipeStart, { passive: true });
    window.addEventListener('touchmove',swipeMove, { passive: true });
  }

  function addSwipeListener(){

  }

  function clearGoods(){
    setGoods([]);
    setPageNum(0);
    setHasMore(true);
  }

  function handleDateChange(ranges){
    setDateRange([ranges.selection]);
    clearGoods();
  }

  function handleMembersChange(e){
    e.stopPropagation();
    var member = e.target.getAttribute("data-member");
    members.includes(member) ? setMembers(members.filter(m => m !== member)) : setMembers([...members,member]);
    clearGoods();
  }

  function handleTypeChange(e){
    e.stopPropagation();
    var type = e.target.getAttribute("data-type");
    types.includes(type) ? setTypes(types.filter(m => m !== type)) : setTypes([...types,type]);
    clearGoods();
  }

  function handlePaymentChange(e){
    e.stopPropagation();
    var payment = e.target.getAttribute("data-payment");
    payments.includes(payment) ? setPayments(payments.filter(m => m !== payment)) : setPayments([...payments,payment]);
    clearGoods();
  }

  function handleMethodChange(e){
    e.stopPropagation();
    var method = e.target.getAttribute("data-method");
    methods.includes(method) ? setMethods(methods.filter(m => m !== method)) : setMethods([...methods,method]);
    clearGoods();
  }

  function buildFilter(){
    var filterArray = [];
    if(types.length > 0){
      filterArray.push("type="+types.join(','));
    }
    if(members.length > 0){
      filterArray.push("members="+members.join(','));
    }
    if(payments.length > 0){
      filterArray.push("payment="+payments.join(','));
    }
    if(methods.length > 0){
      filterArray.push("method="+methods.join(','));
    }
    if(pageNum > -1){
      filterArray.push("pageNum="+pageNum);
    }
    filterArray.push("startDate="+dateRange[0].startDate.toLocaleDateString("en-GB"));
    if(dateRange[0].endDate){
        filterArray.push("endDate="+dateRange[0].endDate.toLocaleDateString("en-GB"));
    }
    if(type === "bookmark"){
      var bookmarkArray = cookies.get("bookmarked");
      if(!bookmarkArray){
        bookmarkArray = [];
      }
      filterArray.push("id="+bookmarkArray.join(','));
    }
    var filterString = filterArray.join('&');
    cookies.set("filter",filterString);
    setFilter(filterString);
  }

  function loadGoods(){
    setLoading(true);
    var url = 'https://script.google.com/macros/s/AKfycbwEC6tY3h9MiQz3hlpAdDzT4kuITXlVnwxG3l0vIkQx7b_z3-jpjkF6KYm1-RUc0pAh3g/exec';
    if(!filter){
      setLoading(false);
      return;
    }
    url += "?"+filter;
    fetch(url)
    .then(function (response) {
      return response.text();
    }).then(function (html) {
      var newGoods = JSON.parse(html);
      if(newGoods.length === 0){
        setHasMore(false);
      }
      setNeedMore(false);
      setGoods(goods => [...goods, ...newGoods]);
      setLoading(false);
    }).catch(function (err) {
      setNeedMore(false);
      setLoading(false);
      console.warn('Something went wrong.', err);
    });
  }

  function renderMissing(){
    return (<div className="missing">未有符合要求資料</div>);
  }

  function renderMoreItem(){
    return (<div className="scroll">向下捲動顯示更多</div>);
  }

  function renderLoading(){
    return (<div className="row"><div className="spinner"><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span></div></div>);
  }

  useEffect(() => {
    var size = 375;
    if(width >= 720){
      if(width >= 1024){
        if(width > 2048){
          size = 3840;
        }else{
          size = 1440;
        }
      }else{
        size = 720;
      }
    }
    var image = require('../image/background_'+size+'.jpg');
    setBackground(image);
    addInfiniteScroll();
    return () => {
      clearGoods();
      window.removeEventListener('wheel',scroll);
      window.removeEventListener('touchstart',swipeStart);
      window.removeEventListener('touchmove',swipeMove);
    }
  }, []);

  useEffect(() => {
    clearGoods();
    buildFilter();
  }, [members,types,payments,methods]);

  useEffect(() => {
    buildFilter();
  }, [pageNum]);

  useEffect(() => {
    if(needMore && !loading && hasMore){
      setPageNum(pageNum+1);
    }else{
      setNeedMore(false);
    }
  }, [needMore]);

  useEffect(() => {
    loadGoods();
  }, [filter]);

  useEffect(() => {
    window.instgrm.Embeds.process();
  }, [goods]);

  return (
    <section id="goods" style={{ backgroundImage : 'url('+ background +')' }}>
      {
        showFilter && <Filter
          members={members}
          payments={payments}
          types={types}
          methods={methods}
          date={dateRange}
          onClose={handleFilterClose}
          onMembersChange={handleMembersChange}
          onTypeChange={handleTypeChange}
          onPaymentChange={handlePaymentChange}
          onMethodChange={handleMethodChange}
          onDateChange={handleDateChange}
        />
      }
      <div id="result">
        <div className="container">
          <ResponsiveMasonry columnsCountBreakPoints={{350: 1, 720: 2, 1024: 3}} gutter="10px" >
             <Masonry gutter="10px">
               {
                 goods.map((item,index) => (
                   <Item key={index} data={item} />
                 ))
               }
             </Masonry>
           </ResponsiveMasonry>
          {
            goods.length === 0 && !loading && renderMissing()
          }
          {
            hasMore && !loading && renderMoreItem()
          }
          {
            loading && renderLoading()
          }
        </div>
      </div>
    </section>
  )
}

export default Goods;
